(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/views/matchview_desktop.js') >= 0) return;  svs.modules.push('/modules/tipset/views/matchview_desktop.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.tipset=_svs.tipset||{};
_svs.tipset.templates=_svs.tipset.templates||{};
svs.tipset.templates.matchview = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"match-view\"></div>\n";
},"useData":true});
Handlebars.partials['svs-tipset-matchview'] = svs.tipset.templates.matchview;
})(svs, Handlebars);

 })(window);